import { getRouteApi } from '@mint/routing';

const routerApi = getRouteApi(
  '/_secured/campaign/$campaignId/planning/buying-plan',
);

export const useChosenVersionId = () => {
  const { flightVersionId } = routerApi.useSearch();

  return flightVersionId;
};
